import Btm from './btm.vue'
export default Btm
